import { useAuthStore } from "@/features/auth/stores/authStore"
import { Card } from "@/shared/components/ui/Card"
import { Badge } from "@/shared/components/ui/Badge"
import { APP_NAME, APP_VERSION } from "@/shared/lib/constants"
import { formatDate } from "@/shared/lib/utils"

export function SettingsPage() {
  const { user } = useAuthStore()

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h1 className="font-roboto text-2xl font-bold text-gray-900">Settings</h1>
        <p className="font-roboto mt-1 text-sm text-gray-600">
          Manage your account and application settings
        </p>
      </div>

      {/* User Profile */}
      <Card>
        <h2 className="font-roboto mb-4 text-lg font-semibold text-gray-900">Profile</h2>
        <div className="space-y-4">
          <div className="flex items-center gap-4">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-500 text-white text-xl font-semibold">
              {user?.fullName?.charAt(0).toUpperCase() || "U"}
            </div>
            <div>
              <h3 className="font-roboto font-semibold text-gray-900">{user?.fullName}</h3>
              <p className="font-roboto text-sm text-gray-600">{user?.email}</p>
              {user?.role && (
                <Badge className="mt-1">{user.role}</Badge>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 pt-4 border-t border-gray-200 sm:grid-cols-2">
            <div>
              <p className="font-roboto text-xs text-gray-500">User ID</p>
              <p className="font-roboto text-sm font-mono text-gray-900">{user?.id}</p>
            </div>
            <div>
              <p className="font-roboto text-xs text-gray-500">Member Since</p>
              <p className="font-roboto text-sm text-gray-900">
                {user?.createdAt ? formatDate(user.createdAt) : "N/A"}
              </p>
            </div>
          </div>
        </div>
      </Card>

      {/* Application Info */}
      <Card>
        <h2 className="font-roboto mb-4 text-lg font-semibold text-gray-900">
          Application Information
        </h2>
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <p className="font-roboto text-sm text-gray-600">Application Name</p>
            <p className="font-roboto text-sm font-medium text-gray-900">{APP_NAME}</p>
          </div>
          <div className="flex items-center justify-between">
            <p className="font-roboto text-sm text-gray-600">Version</p>
            <Badge>{APP_VERSION}</Badge>
          </div>
        </div>
      </Card>

      {/* Preferences Placeholder */}
      <Card>
        <h2 className="font-roboto mb-4 text-lg font-semibold text-gray-900">Preferences</h2>
        <p className="font-roboto text-sm text-gray-600">
          User preferences and customization options coming soon.
        </p>
      </Card>
    </div>
  )
}
